import InputSlider, { Theme } from './input-slider';

export default InputSlider;

export {
    Theme,
};
